module.exports = __webpack_public_path__ + "img/company-honor-RoHS-20241212.689db5ff.jpg";